import React from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { DEFAULT_TEXT_MAX_CHAR_COUNT, EMPTY_TRANSLATIONS } from './form'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import customFieldTypesOptions from 'constants/customFieldTypesOptions'
import CustomFieldType from 'constants/CustomFieldTypes'
import moment from 'moment'

export default function FieldTypeSelectField ({ disabled }) {
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()

  const handleTypeChange = (newValue) => {
    const setValue = (newValue) => {
      setFieldValue('maxCharCount', newValue.maxCharCount)
      setFieldValue('selectOptions', newValue.selectOptions)
      setFieldValue('defaultValue', newValue.defaultValue)
    }

    switch (newValue) {
      case CustomFieldType.Boolean:
        setValue({ defaultValue: { bool: false } })
        break
      case CustomFieldType.Date:
        setValue({ defaultValue: { date: moment() } })
        break
      case CustomFieldType.DateTime:
        setValue({ defaultValue: { dateTime: moment() } })
        break
      case CustomFieldType.Text:
        setValue({
          defaultValue: { text: '' },
          maxCharCount: DEFAULT_TEXT_MAX_CHAR_COUNT
        })
        break
      case CustomFieldType.Select:
        setValue({ selectOptions: [{ ...EMPTY_TRANSLATIONS, isDefault: true }] })
        break
      default:
    }
  }

  return <ControlledSelectField
    fieldName={'type'}
    label={t('customField.form.type')}
    options={customFieldTypesOptions}
    onChange={newValue => handleTypeChange(newValue)}
    getOptionValue={type => type.value}
    getOptionLabel={type => t(type.label)}
    disableClear
    disabled={disabled}
  />
}
